import React, { useState, useEffect } from 'react';
import View from 'src/components/view';
import utils from 'src/components/utils';
import Element from 'src/components/element';
import MenuCarrinho from 'src/components/menu_carrinho';
import userEvent from '@testing-library/user-event';

function MeusPedidos() {
  let [view, setView] = useState({});
  let [element, setElement] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {}, tabSel: 'PEDIDOS' });
  let [classificacao, setClassificacao] = useState({});
  let [ready, setReady] = useState(false);
  let [index, setIndex] = useState(0);
  let user = utils.getUser();

  const createElement = function () {
    return {
      elements: {
        tabs: {
          type: 'list',
          layout: 'tab-menu',
          search: false,
          rendered: user.tipo === 'CLIENTE',
          controls: false,
          itemVar: 'ti',
          rowStyleClass: '${ti.key === crud.tabSel ? "ui-tab-menu-sel" : ""}',
          header: false,
          columns: {
            label: { type: 'span' },
          },
          click: {
            action: 'setarTab',
          },
          data: [
            { label: 'PEDIDOS', key: 'PEDIDOS' },
            { label: utils.lng('orcamento', 'ORÇAMENTOS'), key: 'ORCAMENTOS' },
          ],
        },
        pedidos: {
          name: 'itens',
          type: 'list',
          layout: 'table',
          rows: 10,
          rendered: "${crud.tabSel === 'PEDIDOS'}",
          add: false,
          showLabel: true,
          header: false,
          rowStyleClass: "${'ui-row-' + @this.constante_status}",
          list: {
            url: 'listarMeusPedidos?orcamento=false',
          },
          columns: {
            numero_pedido: {
              type: 'span',
              value: "${'Pedido ' + @this.numero_pedido}",
              columnStyleClass: "${'ui-col-status-ped ui-col-' + @this.constante_status}",
            },
            dh_registro: { label: 'Data do pedido', type: 'span', bold: true },
            valor_total: { label: 'Valor total', type: 'span', format: 'money', bold: true },
            quantidade: { label: 'Itens no pedido', type: 'span', bold: true },
            descricao_status: { label: 'Status do pedido', type: 'span', bold: true },
            [utils.lng('Ver detalhes', 'Ver detalhes')]: {
              type: 'button',
              disabled: '${!@this.is_administrativo && @this.bloquear_edicao}',
              label: utils.lng('Ver detalhes', 'Ver detalhes'),
              click: {
                action: 'open',
                url: '/carrinho/pedido/{id_pedido}',
              },
            },
          },
        },
        orcamento: {
          name: 'itens',
          type: 'list',
          layout: 'table',
          rows: 10,
          rendered: "${crud.tabSel !== 'PEDIDOS'}",
          add: false,
          showLabel: true,
          header: false,
          rowStyleClass: "${'ui-row-' + @this.constante_status}",
          list: {
            url: 'listarMeusPedidos?orcamento=true',
          },
          columns: {
            numero_pedido: {
              type: 'span',
              value: "${'Pedido ' + @this.numero_pedido}",
              columnStyleClass: "${'ui-col-status-ped ui-col-' + @this.constante_status}",
            },
            dh_registro: { label: 'Data do pedido', type: 'span', bold: true },
            valor_total: { label: 'Valor total', type: 'span', format: 'money', bold: true },
            quantidade: { label: 'Itens no pedido', type: 'span', bold: true },
            descricao_status: { label: 'Status do pedido', type: 'span', bold: true },
            detalhes: {
              type: 'button',
              disabled: '${!@this.is_administrativo && @this.bloquear_edicao}',
              label: 'VER DETALHES',
              click: {
                action: 'open',
                url: '/carrinho/pedido/{id_pedido}',
              },
            },
          },
        },
      },
    };
  };

  if (!ready) {
    element = createElement();
    setElement(element);
    ready = true;
    setReady(true);
  }

  crud.open = function (value, args) {
    const click = value.click;

    if (!click) {
      return;
    }
    const data = args.data;
    let d = {};
    let url = click.url;

    for (const i in data) {
      const v = data[i];
      const b = '{' + i + '}';
      const c = v + '';

      url = url.replace(b, c);
    }
    d.path = url;
    d.label = click.label;

    window.location.href = url;
  };

  crud.setarTab = function (el, args) {
    crud.tabSel = args.data.key;

    element = createElement();
    setElement(element);

    index = index + 1;
    setIndex(index + 1);
    setCrud(crud);
    setElement(element);
  };

  return (
    <View name="meus-pedidos">
      <div className="ui-meus-pedidos">
        <Element index={index} value={element} crud={crud} data={crud.data} view={view}></Element>
      </div>
    </View>
  );
}

export default MeusPedidos;
